module.exports = __webpack_public_path__ + "static/media/logo_gym.c0d81e27.png";